export enum FormSelectCustomOptionsEnum {
  VACANCY_COMPANY = 'VACANCY_COMPANY',
}
